import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(old)')({
  beforeLoad: ({ context }) => {
    if (context.releaseAssortmentIA) {
      throw redirect({ to: '/new/in-season' });
    }
  },
  component: Outlet,
});
